import { render, staticRenderFns } from "./other-configuration.vue?vue&type=template&id=dd14115a&scoped=true&"
import script from "./other-configuration.vue?vue&type=script&lang=js&"
export * from "./other-configuration.vue?vue&type=script&lang=js&"
import style0 from "./other-configuration.vue?vue&type=style&index=0&id=dd14115a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd14115a",
  null
  
)

export default component.exports